/**
 * This file is part of the <%= name %> application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import '@babel/polyfill/noConflict';
import React from 'react';
import { render } from 'react-dom';
import { getProps } from 'utils/DOM';
import registerDecoration from 'utils/registerDecoration';
import objectFitImages from 'object-fit-images';
import picturefill from 'picturefill';
import getScrollbarWidth from 'utils/getScrollbarWidth';
import App from './components/ProgramApp/ProgramApp';
import linedText from 'decorators/lined-text';
import staggerText from 'decorators/staggerText';
import inview from 'decorators/inview';
import dropcap from 'decorators/dropcap';
import appearText from 'decorators/appearText';
import stagger from 'decorators/stagger';

document.documentElement.style.setProperty(
  '--scrollbar-width',
  `${getScrollbarWidth()}px`
);

registerDecoration('.lined-text', linedText);

registerDecoration('[stagger-text]', staggerText, {
  duration: 0.5,
  threshold: [0, 0.7, 1],
  rootMargin: '50px 0px 0px 0px',
});

registerDecoration('[appear]', inview, {
  name: 'appear',
  timeout: 10000,
  threshold: [0, 0.5, 1],
  rootMargin: '300px 300px 0px 0px',
  props: ['transform'],
  once: true,
});

registerDecoration('[dropcap] p:first-child', dropcap, { lines: 2 });

registerDecoration('[appear-text]', appearText, {
  timeout: 10000,
  threshold: [0, 0.7, 1],
  rootMargin: '0px 0px 50px 0px',
  props: ['opacity'],
  once: true,
});

registerDecoration('[stagger]', stagger, {
  threshold: [0.3, 1],
});

const rootEl = document.getElementById('root');

/**
 * Render React.
 */
if (rootEl) {
  const props = getProps(rootEl);
  render(<App {...props} />, rootEl);
}
picturefill();
objectFitImages();
